import { CellProps } from 'react-table';
import { FormattedDateDisplay } from './FormattedDateDisplay';

export default function DateCell(props: CellProps<[]>) {
  return <FormattedDateDisplay date={props.value} />;
}
